(function() {
  'use strict';

  // --- ENTRY SOURCE ---
  // Non-UTM ?src= param (e.g. blog-rollsdown) so we can see which page
  // drove each quiz start / email in GA4, without touching acquisition source.
  var entrySource = 'direct';
  try {
    var _srcParam = new URLSearchParams(window.location.search).get('src');
    if (_srcParam) entrySource = _srcParam.slice(0, 60);
  } catch (e) {}

  // --- QUIZ DATA ---

  var questions = [
    {
      id: 1, text: 'Open your top drawer. What do you see?', type: 'four',
      answers: [
        { text: 'Five identical pairs, neatly folded', scores: { purist: 1 } },
        { text: 'Everything in its place, organized by type or color', scores: { ritualist: 1 } },
        { text: 'A few favorites I reach for by feel', scores: { sensualist: 1 } },
        { text: 'A little bit of everything from every phase of my life', scores: { collector: 1 } }
      ]
    },
    {
      id: 2, text: 'When something you own wears out, you tend to:', type: 'two',
      answers: [
        { text: 'Replace it with the exact same thing', scores: { purist: 1, ritualist: 1 } },
        { text: 'See it as an excuse to try something new', scores: { sensualist: 1, collector: 1 } }
      ]
    },
    {
      id: 3, text: 'What actually matters most in what you wear underneath?', type: 'four',
      answers: [
        { text: 'That I never have to think about it', scores: { purist: 1 } },
        { text: 'That it sets the tone for the rest of the outfit', scores: { ritualist: 1 } },
        { text: 'That the fabric feels right against my skin', scores: { sensualist: 1 } },
        { text: 'That I have options depending on my mood', scores: { collector: 1 } }
      ]
    },
    {
      id: 4, text: 'Your morning routine is more like:', type: 'two',
      answers: [
        { text: 'A system. Dialed in, don\'t mess with it', scores: { purist: 1, ritualist: 1 } },
        { text: 'Depends on the day, depends on how I feel', scores: { sensualist: 1, collector: 1 } }
      ]
    },
    {
      id: 5, text: 'Someone recommends a new brand to you. Your first instinct?', type: 'four',
      answers: [
        { text: 'I\'m good, I already know what I like', scores: { purist: 1 } },
        { text: 'I\'ll research it, read reviews, compare it to what I have', scores: { ritualist: 1 } },
        { text: 'I\'ll try it if the material or feel looks interesting', scores: { sensualist: 1 } },
        { text: 'Already adding to cart', scores: { collector: 1 } }
      ]
    }
  ];

  var personas = {
    purist: {
      name: 'The Purist',
      headline: 'You know exactly what you want.',
      description: 'While everyone else is still figuring it out, you figured it out a long time ago. Your essentials drawer isn\'t boring, it\'s edited. Variety has never been the point for you. The things that earn a place in your life stay there.',
      shareLine: 'My drawer has five of the same thing and zero regrets.'
    },
    ritualist: {
      name: 'The Ritualist',
      headline: 'Nothing you do is accidental.',
      description: 'Getting dressed from the inside out is part of how you set the day. You\'re not particular, you\'re intentional. The details nobody sees? Those are the ones that matter most to you. There\'s a reason for everything in your drawer and you could explain every one.',
      shareLine: 'Yes, I have a system for getting dressed. No, I won\'t apologize for it.'
    },
    sensualist: {
      name: 'The Sensualist',
      headline: 'If it doesn\'t feel right, it doesn\'t stay.',
      description: 'You trust your body\'s opinion over a label, a review, or a recommendation. Comfort isn\'t a compromise for you, it\'s a standard. You\'ll keep something for years because nothing else matches how it feels against your skin. Your favorites are favorites for a reason.',
      shareLine: 'I choose everything by feel. I\'ve never been wrong.'
    },
    collector: {
      name: 'The Collector',
      headline: 'Your drawer is a timeline and you love every chapter.',
      description: 'You\'ve never met an impulse buy you regretted for long. Your essentials drawer has range. The practical pair, the aspirational pair, the "I\'ll wear this eventually" pair. You see possibility in options and you\'re not interested in editing yourself down to one mood.',
      shareLine: 'My drawer is chaos and I know exactly where everything is.'
    }
  };

  // Your match — code-free product tease per persona. Same mapping and copy
  // used in the Klaviyo welcome emails, for consistency between the two.
  // NOTE: intentionally no discount codes or UTMs here — the offer only
  // lives in the welcome email, and internal links stay UTM-free so they
  // don't clobber real acquisition-source reporting.
  var products = {
    purist: {
      title: 'The Essential 3-Pack',
      price: '$35',
      bridge: 'The edit that matches how you buy: nothing extra, nothing missing.',
      url: '/products/seamless-underwear-essential-3-pack',
      image: 'https://cdn.shopify.com/s/files/1/0562/6570/3602/files/Three_pair_set_of_seamless_undies_that_don_t_ride_up_or_cause_wedgies.jpg?v=1775052382'
    },
    ritualist: {
      title: 'Everyday Essentials 4-Pack',
      price: '$47',
      bridge: 'A full rotation, so your system never has to skip a beat.',
      url: '/products/seamless-underwear-4-pack',
      image: 'https://cdn.shopify.com/s/files/1/0562/6570/3602/files/Four_pack_of_seamless_undies_that_don_t_ride_up.jpg?v=1775053345'
    },
    sensualist: {
      title: 'Rich Tones 2-Pack',
      price: '$29',
      bridge: 'Two you\'ll actually reach for, in tones that feel like you.',
      url: '/products/rich-tones-seamless-briefs-2-pack',
      image: 'https://cdn.shopify.com/s/files/1/0562/6570/3602/files/Two_pair_set_of_seamless_undies_that_don_t_ride_up_or_cause_wedgies.jpg?v=1775052312'
    },
    collector: {
      title: 'Soft & Bold 3-Pack',
      price: '$35',
      bridge: 'Range in one set: the next chapter for your drawer.',
      url: '/products/seamless-briefs-soft-bold-3-pack',
      image: 'https://cdn.shopify.com/s/files/1/0562/6570/3602/files/Three_pair_seamless_underwear_set_that_doesn_t_ride_up_or_cause_wedgies.jpg?v=1775052222'
    }
  };

  // --- ANALYTICS ---
  // Pushes to dataLayer (and gtag if present) for GTM to pick up.
  // Events: cpq_quiz_start, cpq_quiz_answer, cpq_result_view, cpq_match_click,
  // cpq_email_submit, cpq_share_click — each carries persona/product where relevant.
  function track(name, params) {
    try {
      var p = params || {};
      p.entry_source = entrySource;
      var payload = { event: name };
      for (var k in p) { if (p.hasOwnProperty(k)) payload[k] = p[k]; }
      (window.dataLayer = window.dataLayer || []).push(payload);
      if (typeof window.gtag === 'function') { window.gtag('event', name, p); }
    } catch (e) {}
  }

  // --- STATE ---

  var scores = { purist: 0, ritualist: 0, sensualist: 0, collector: 0 };
  var currentQuestion = 0;
  var q1Answer = null;
  var result = null;
  var answerHistory = [];

  // --- DOM ---

  var section = document.getElementById('comfort-profile-quiz');
  if (!section) return;

  var states = {
    intro: section.querySelector('[data-state="intro"]'),
    quiz: section.querySelector('[data-state="quiz"]'),
    result: section.querySelector('[data-state="result"]')
  };

  var progressFill = section.querySelector('[data-progress]');
  var progressText = section.querySelector('[data-progress-text]');
  var questionContainer = section.querySelector('[data-question-container]');
  var backBtn = section.querySelector('[data-action="back"]');
  var toast = document.getElementById('cpq-toast');
  var matchWrap = section.querySelector('[data-match]');

  // --- DOODLE CYCLING ---

  var cyclingDoodles = section.querySelectorAll('[data-doodle-cycle]');
  var personaDoodles = section.querySelectorAll('[data-doodle-persona]');
  var fallbackImg = section.querySelector('[data-doodle-fallback]');
  var currentDoodleIndex = 0;
  var doodleCycleTimer = null;
  var DOODLE_INTERVAL = 2800; // ms per doodle

  function startDoodleCycle() {
    // Always stop any existing cycle first to prevent duplicate intervals
    stopDoodleCycle();

    // Instantly hide everything via inline style (bypasses CSS transition)
    cyclingDoodles.forEach(function(img) {
      img.classList.remove('cpq__doodle-img--visible');
      img.style.opacity = '0';
    });
    personaDoodles.forEach(function(img) {
      img.classList.remove('cpq__doodle-img--visible');
      img.style.opacity = '0';
    });

    // Handle fallback
    if (fallbackImg) {
      fallbackImg.style.opacity = cyclingDoodles.length === 0 ? '1' : '0';
    }

    if (cyclingDoodles.length === 0) return;

    // Clear inline overrides on cycling doodles so CSS transitions work again
    cyclingDoodles.forEach(function(img) {
      img.style.opacity = '';
    });

    // Show first cycling doodle
    currentDoodleIndex = 0;
    cyclingDoodles[currentDoodleIndex].classList.add('cpq__doodle-img--visible');

    // Cycle if more than one
    if (cyclingDoodles.length > 1) {
      doodleCycleTimer = setInterval(function() {
        cyclingDoodles[currentDoodleIndex].classList.remove('cpq__doodle-img--visible');
        currentDoodleIndex = (currentDoodleIndex + 1) % cyclingDoodles.length;
        cyclingDoodles[currentDoodleIndex].classList.add('cpq__doodle-img--visible');
      }, DOODLE_INTERVAL);
    }
  }

  function stopDoodleCycle() {
    if (doodleCycleTimer) {
      clearInterval(doodleCycleTimer);
      doodleCycleTimer = null;
    }
  }

  function showPersonaDoodle(personaKey) {
    stopDoodleCycle();

    // Instantly kill all cycling doodles (inline opacity bypasses the fade)
    cyclingDoodles.forEach(function(img) {
      img.classList.remove('cpq__doodle-img--visible');
      img.style.opacity = '0';
    });

    // Hide fallback
    if (fallbackImg) {
      fallbackImg.style.opacity = '0';
    }

    // Clear any previous persona, then show the match
    personaDoodles.forEach(function(img) {
      img.classList.remove('cpq__doodle-img--visible');
      img.style.opacity = '';
    });

    var match = section.querySelector('[data-doodle-persona="' + personaKey + '"]');
    if (match) {
      match.classList.add('cpq__doodle-img--visible');
    }
  }

  // Start cycling on page load
  startDoodleCycle();

  // --- TOAST ---

  function showToast(msg) {
    toast.textContent = msg;
    toast.classList.add('cpq__toast--visible');
    setTimeout(function() { toast.classList.remove('cpq__toast--visible'); }, 2000);
  }

  // --- UTILITIES ---

  function showState(name) {
    Object.keys(states).forEach(function(key) {
      states[key].style.display = key === name ? '' : 'none';
    });
    var contentEl = section.querySelector('.cpq__split-content');
    if (contentEl) contentEl.scrollTop = 0;
  }

  function updateProgress() {
    var pct = ((currentQuestion + 1) / questions.length) * 100;
    progressFill.style.width = pct + '%';
    progressText.textContent = (currentQuestion + 1) + ' / ' + questions.length;
  }

  function getWinner() {
    var max = -1;
    var winner = null;
    Object.keys(scores).forEach(function(k) {
      if (scores[k] > max) { max = scores[k]; winner = k; }
    });
    var tied = Object.keys(scores).filter(function(k) { return scores[k] === max; });
    if (tied.length > 1 && q1Answer) {
      var tb = Object.keys(q1Answer)[0];
      if (tied.indexOf(tb) > -1) winner = tb;
    }
    return winner;
  }

  // --- RENDER ---

  function renderQuestion(index) {
    var q = questions[index];
    var html = '<div class="cpq__question" data-question="' + q.id + '">';
    html += '<h3 class="cpq__question-text">' + q.text + '</h3>';
    html += '<div class="cpq__answers">';
    q.answers.forEach(function(a, i) {
      html += '<button class="cpq__answer" data-answer="' + i + '"><span>' + a.text + '</span></button>';
    });
    html += '</div></div>';
    questionContainer.innerHTML = html;
    backBtn.style.display = index > 0 ? '' : 'none';
    requestAnimationFrame(function() {
      var el = questionContainer.querySelector('.cpq__question');
      if (el) el.classList.add('cpq__question--visible');
    });
  }

  function renderMatch(personaKey) {
    if (!matchWrap) return;
    var prod = products[personaKey];
    if (!prod) { matchWrap.style.display = 'none'; return; }

    var bridgeEl = matchWrap.querySelector('[data-match-bridge]');
    var linkEl = matchWrap.querySelector('[data-match-link]');
    var imgEl = matchWrap.querySelector('[data-match-img]');
    var nameEl = matchWrap.querySelector('[data-match-name]');
    var priceEl = matchWrap.querySelector('[data-match-price]');

    if (bridgeEl) bridgeEl.textContent = prod.bridge;
    if (linkEl) linkEl.setAttribute('href', prod.url);
    if (imgEl) { imgEl.setAttribute('src', prod.image); imgEl.setAttribute('alt', prod.title); }
    if (nameEl) nameEl.textContent = prod.title;
    if (priceEl) priceEl.textContent = prod.price;

    matchWrap.style.display = '';
  }

  function renderResult(personaKey) {
    var persona = personas[personaKey];
    section.querySelector('[data-result-name]').textContent = persona.name;
    section.querySelector('[data-result-headline]').textContent = persona.headline;
    section.querySelector('[data-result-description]').textContent = persona.description;

    // Show persona-specific doodle, stop cycling
    showPersonaDoodle(personaKey);

    // Populate the code-free product match
    renderMatch(personaKey);

    result = personaKey;
    showState('result');

    var prod = products[personaKey];
    track('cpq_result_view', { persona: personaKey, product: prod ? prod.title : null });
  }

  // --- KLAVIYO ---

  function submitToKlaviyo(email, personaKey) {
    var listId = section.dataset.klaviyoListId || '';
    var companyId = section.dataset.klaviyoCompanyId || '';

    if (!listId || !companyId) {
      console.warn('Klaviyo: missing list ID or company ID. listId="' + listId + '" companyId="' + companyId + '"');
      return Promise.resolve();
    }

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'comfort_profile_quiz',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    comfort_profile: personaKey
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      })
    }).then(function(response) {
      if (!response.ok) {
        return response.text().then(function(body) {
          console.error('Klaviyo error ' + response.status + ':', body);
          throw new Error('Klaviyo request failed: ' + response.status);
        });
      }
      return response;
    });
  }

  // --- EVENTS ---

  section.addEventListener('click', function(e) {
    var t = e.target.closest('[data-action], [data-answer], [data-match-link]');
    if (!t) return;

    if (t.hasAttribute('data-match-link') && !t.hasAttribute('data-action')) {
      var mp = products[result];
      track('cpq_match_click', { persona: result, product: mp ? mp.title : null });
      return; // let the <a> navigate normally
    }

    if (t.dataset.action === 'start') {
      currentQuestion = 0;
      scores = { purist: 0, ritualist: 0, sensualist: 0, collector: 0 };
      q1Answer = null; result = null; answerHistory = [];
      startDoodleCycle();
      showState('quiz'); updateProgress(); renderQuestion(0);
      track('cpq_quiz_start', {});
      return;
    }

    if (t.dataset.answer !== undefined) {
      var ai = parseInt(t.dataset.answer, 10);
      var q = questions[currentQuestion];
      var a = q.answers[ai];
      t.classList.add('cpq__answer--selected');
      answerHistory.push({ questionIndex: currentQuestion, scores: a.scores });
      Object.keys(a.scores).forEach(function(k) { scores[k] += a.scores[k]; });
      if (currentQuestion === 0) q1Answer = a.scores;
      track('cpq_quiz_answer', { question: currentQuestion + 1 });
      setTimeout(function() {
        currentQuestion++;
        if (currentQuestion < questions.length) { updateProgress(); renderQuestion(currentQuestion); }
        else { renderResult(getWinner()); }
      }, 300);
      return;
    }

    if (t.dataset.action === 'back') {
      if (currentQuestion <= 0 || answerHistory.length === 0) return;
      var la = answerHistory.pop();
      Object.keys(la.scores).forEach(function(k) { scores[k] -= la.scores[k]; });
      if (la.questionIndex === 0) q1Answer = null;
      currentQuestion = la.questionIndex;
      updateProgress(); renderQuestion(currentQuestion);
      return;
    }

    if (t.dataset.action === 'share') {
      if (!result) return;
      track('cpq_share_click', { persona: result });
      var p = personas[result];
      var shareUrl = window.location.origin + '/pages/quiz-the-' + result + '?utm_source=quiz_share&utm_content=' + result;
      var shareTitle = "I'm " + p.name;
      var shareText = "I'm " + p.name + '. ' + p.shareLine + ' What does your drawer say about you?';

      // Use native share sheet on mobile if available
      if (navigator.share) {
        navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        }).catch(function() {
          // User cancelled or share failed — no action needed
        });
      } else {
        // Desktop fallback: copy to clipboard
        navigator.clipboard.writeText(shareText + ' ' + shareUrl).then(function() {
          showToast('Link copied to clipboard');
        });
      }
      return;
    }

    if (t.dataset.action === 'submit-email') {
      var input = section.querySelector('[data-email-input]');
      var form = section.querySelector('.cpq__email-form');
      var email = input.value.trim();
      if (!email || !input.validity.valid) { form.classList.add('cpq__email-form--error'); return; }
      form.classList.remove('cpq__email-form--error');
      t.disabled = true;
      t.textContent = '...';
      submitToKlaviyo(email, result).then(function() {
        form.style.display = 'none';
        section.querySelector('[data-email-success]').style.display = '';
        var ep = products[result];
        track('cpq_email_submit', { persona: result, product: ep ? ep.title : null });
      }).catch(function() {
        t.disabled = false;
        t.textContent = 'SEND';
      });
      return;
    }

    if (t.dataset.action === 'retake') {
      currentQuestion = 0;
      scores = { purist: 0, ritualist: 0, sensualist: 0, collector: 0 };
      q1Answer = null; result = null; answerHistory = [];
      section.querySelector('.cpq__email-form').style.display = '';
      section.querySelector('.cpq__email-form').classList.remove('cpq__email-form--error');
      section.querySelector('[data-email-success]').style.display = 'none';
      section.querySelector('[data-email-input]').value = '';
      var emailBtn = section.querySelector('[data-action="submit-email"]');
      if (emailBtn) { emailBtn.disabled = false; emailBtn.textContent = 'SEND'; }
      startDoodleCycle();
      showState('quiz'); updateProgress(); renderQuestion(0);
      track('cpq_quiz_start', { retake: true });
      return;
    }
  });

  // --- AUTO-START FOR BLOG-REFERRED TRAFFIC ---
  // If this page load came from a blog CTA (?src= present), skip the intro
  // screen and jump straight to question 1 — the CTA already delivered the
  // persona tease, so re-showing that copy here is redundant. Direct/organic
  // entry (homepage, IG bio, bookmarked) still sees the intro as before.
  if (entrySource !== 'direct') {
    currentQuestion = 0;
    scores = { purist: 0, ritualist: 0, sensualist: 0, collector: 0 };
    q1Answer = null; result = null; answerHistory = [];
    showState('quiz'); updateProgress(); renderQuestion(0);
    track('cpq_quiz_start', { auto_start: true });
  }

})();
